import React, { PureComponent } from 'react';

import styled from 'styled-components';

import Box from '../../atoms/Box/Box';
import Text from '../../atoms/Text/Text';

import { I18nTranslation } from '@shared/interfaces/i18n';
import { withTranslation } from 'i18n';

type PoweredByStripeProps = {
  className?: string;
  t: I18nTranslation;
};

class PoweredByStripe extends PureComponent<PoweredByStripeProps> {
  render() {
    return (
      <Box 
        backgroundColor="fiord" 
        pl={0.375} 
        pr={0.375} 
        data-cy="powered-by-stripe-box"
        {...this.props}
      >
        <Text
          color="white"
          smSize={0.625}
          size={0.875}
          weight={600}
          lineHeight={1.5}
        >
          {this.props.t('poweredBy')}
        </Text>
        <Text
          color="white"
          smSize={1.125}
          size={1.25}
          weight="bold"
          lineHeight={1.5}
        >
          stripe
        </Text>
      </Box>
    );
  }
}

const styledPoweredByStripe = styled(
  withTranslation('common')(PoweredByStripe)
)`
  opacity: 0.5;
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export default styledPoweredByStripe;
